export default "__VITE_ASSET__Cr9TM5oI__"